import React from 'react';
import FeatureUnavailable from '../../components/activation/FeatureUnavailable';
import LegacyFeatureLocked from './LegacyFeatureLocked';
import { useEntitlements } from '../../hooks/useEntitlements';

/**
 * "This feature isn't in your plan" panel - the single entry point the gates and the
 * 17 inline-402 sites use. WHEN it renders is still decided by the callers.
 *
 *  - Non-restaurant accounts: the ONE calm card (FeatureUnavailable). `feature`, `title`
 *    and `message` are ignored: no backend English text and no raw flag key are shown.
 *  - Restaurant accounts (and anything where the company is not yet known): the ORIGINAL
 *    panel, untouched (LegacyFeatureLocked), so a restaurant account is byte-identical to
 *    before 6A even in a locked state.
 */
export default function FeatureLocked(props) {
  const { ready, isRestaurant } = useEntitlements();
  if (!ready || isRestaurant) return <LegacyFeatureLocked {...props} />;
  return <FeatureUnavailable />;
}
